<h2 mat-dialog-title>{{ 'send_report_email_title' | translate }}</h2>

<mat-dialog-content>
  <p class="description">{{ 'send_report_email_description' | translate }}</p>

  <mat-form-field class="emails-field">
    <mat-label>{{ 'send_report_email_label' | translate }}</mat-label>
    <mat-chip-grid #chipGrid [disabled]="loading">
      <mat-chip-row *ngFor="let email of emails" (removed)="remove(email)">
        {{ email }}
        <button matChipRemove [attr.aria-label]="email">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
      <input type="email" [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeys"
             [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="add($event)" (input)="onTyping()" cdkFocusInitial>
    </mat-chip-grid>
    <mat-hint>{{ 'send_report_email_hint' | translate }}</mat-hint>
  </mat-form-field>

  <p *ngIf="error" class="dialog-error">{{ error | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'generic_text_cancel' | translate }}</button>
  <button mat-button (click)="save()" [disabled]="loading || saving">{{ 'generic_text_save' | translate }}</button>
</mat-dialog-actions>
